<template>
  <div id="wrap" class="out">
    <div class="anli_detail_banner">
      <img src="https://www.kingdee.com/news-static/img/anli_detail/banner.png">
      <div class="text">
        <div class="w1000">
          <h2 class="fnt_18 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">德邦快递引入金蝶咨询，通过蓝图设计，实现了在集团管控模式下的整体信息化规划，使德邦的财务管理和 ERP工具得到了很好地融合。信息化建设助推了德邦的快速发展，并为德邦的管理带来了实实在在的效果。– 德邦集团财务部及信息部
          </h2>
          <div class="banner-text fnt_16 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">———德邦集团财务部及信息部</div>
        </div>
      </div>
    </div>
    <div class="anli_detail_tag">
      <div class="w1000">
        <div class="anli_tag_text">
          <div class="text">
            <div class="num_list">
              <div class="num_item">
                <div class="fnt_32">
                  <span>99%</span>
                </div>
                <div class="sub_text fnt_14">自动化财务核算</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>低于1%</span>
                </div>
                <div class="sub_text fnt_14">手工凭证量</div>
              </div>
              <div class="num_item">
                <div class="fnt_32">
                  <span>减少60人</span>
                </div>
                <div class="sub_text fnt_14">财务人员</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anli_detail_article">
      <div class="w1000">
        <h1>德邦物流： 川流汇聚 精准服务</h1>
        <div class="detail_article">
          <div class="anli_item">
            <div class="subtitle fnt_24">客户概述</div>
            <div class="summary fnt_16">
              <p>德邦快递自1996年成立，现已成长为一家以大件快递为主力，联动快递、物流、跨境、仓储与供应链的综合性物流供应商，并于2018年在上海证券交易所挂牌上市。</p>
              <p>德邦快递始终紧随客户需求而持续创新，坚持自营门店与事业合伙人相结合的网络拓展模式，搭建优选线路，以优化运力成本，为客户提供快速高效、便捷及时、安全可靠的服务。截至2018年3月，公司网点近10000家，服务网络覆盖全国34个省级行政区，全国转运中心总面积超过124万平米。德邦快递正从国际快递、跨境电商、国际贷代三大方向切入跨境市场，已开通韩国、日本、泰国等多条国际线路，全球员工人数超过12万名。</p>
              <p>&nbsp;</p>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">业务挑战</div>
              <div class="summary fnt_16">
                <p>德邦物流自2006年和金蝶合作以来，金蝶伴随的德邦的快速成长不断地发展自身的产品，从金蝶2000到金蝶K/3财务系统再到金蝶EAS5.4、EAS财务7.0不断的满足德邦在不同发展时期的需求，自德邦2011年使用金蝶EAS集团财务7.0已经有7个年头，在这期间德邦的业务飞速发展，整个体量不断快速增长：</p>
                <p>财务人员队伍庞大，给人员管理和财务管理带来了一定困难;</p>
                <p>未建立完善的集团财务管控体系，不能充分支持公司经营管理决策;</p>
                <p>缺乏有效的资金计划管理，预算管理不全面，资金管理的安全和效率无法保证;</p>
                <p>规划未满足业务需求，制约业务的发展和管理的深入。</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">解决方案</div>
              <div class="summary fnt_16">
                <p>2018年德邦与金蝶合作推进财务信息化升级，以快速出具财务合规性报告和管理精细化报告为核心，以财务核算共享为基础，建立集团财务管理与监控信息系统，实现数据集中、信息透明、管理高效。企业的财务核算系统是实现财务共享服务的基础和保障, 只有在信息系统支持下，财务共享服务模式才可以跨越地理距离的障碍，向其服务对象提供内容广泛的、持续的、反应迅速的服务。因此,系统平台的统一搭建和整合是实现共享服务的关键环节。统一的ERP系统是保证共享服务平台顺利搭建的关键因素。建立一个好的平台很重要，需要有一个统一的IT标准和一个流程标准，这样整合可以更快。</p>
                <p>搭建财务共享服务中心体系，还需完成财务共享服务系统与其他系统的对接。财务共享服务平台系统与费用报销系统、影像扫描系统、银企互联系统、业务管理系统、移动终端应用等相对接，实现各信息系统的业务集成和数据共享，实现数据集中、信息透明、管理高效。</p>
                <p>德邦财务核算系统平台以满足德邦未来6-8年的发展需求为建设目标。通过财务核算系统的应用，实现以下目标：</p>
                <p>财务报表和管理报表自动实时出具;</p>
                <p>财务核算自动化率达到99%以上;</p>
                <p>报表实现多维分析;</p>
                <p>财务账和管理账自动分离;</p>
                <p>集成异构系统数据自动生成凭证;</p>
                <p>异构系统与财务核算系统实现数据校对;</p>
                <p>符合上市公司要求的账务处理逻辑</p>
                <p>保证账务质量和时效要求;财务系统升级后，将整个财务平台前移，通过EIP集成平台，理清业务数据，自动化对接、自动化财务记账、系统进行财务数据与业务系统的校对;分开财务和管理两条线，做到财务合规化，管理精细化互不干扰;最终达到90%业务在EIP处理，财务核算只占10%的工作，财务核算95%都是自动化处理。</p>
                <p>从四个方面提升工作效率：</p>
                <p>1、基础资料系统对接同步，并一键分配</p>
                <p>2、开发统一对外端口，归集业务数据自动生成凭证;</p>
                <p>3、内部往来核销业务自动化，涉及往来的业务在凭证审核后自动触发往来接收。</p>
                <p>4、合并报表自动处理：通过设置调度任务的方式实现个报到集团合并操作的自动化。</p>
                <p>从三方面提升管理报表核算效率：</p>
                <p>1、数据整合，系统所有数据通过系统对接取数，线下数据统一端口导入、提升业务数据的整合，从痕迹管理和数据质量方面提升财务核算工作质量：</p>
                <p>2、财管科目分离：通过财报/管报分离，减少管理报表手工还原和线下操作，提升报表出具时效;</p>
                <p>3、利润中心：新增管报利润中心，通过搭建管报的组织架构、凭证取数实现报表出具的灵活性。</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="anli_item">
              <div class="subtitle fnt_24">客户价值</div>
              <div class="summary fnt_16">
                <p>1、 系统升级后性能提升10倍以上，给用户带来舒适的系统体验。</p>
                <p>2、 系统在至少7个方面实现财务自动化处理</p>
                <p>3、 系统实施后给客户带来极大的成本节约</p>
                <p>通过实施ERP公司在业务效率及系统效率两方面带来的提升，使得客户在财务共享中心在人员大幅减少的同时保证业务服务的质量提升。系统实施后财务共享中心人员减少60人。</p>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CircleBtn @back="back" />

    <!-- <div class="floor" style="display: block;">
      <ul class="fnt_16">
        <li class="">农业农村局</li>
        <li class="">招商局</li>
        <li class="active">京东科技</li>
        <li class="">德邦物流</li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Successcase4',
  components: { CircleBtn },

  data() {
    return {
    }
  },
  mounted() {
    document.querySelector('#wrap').scrollIntoView(true)
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.out {
  padding-bottom: 50px;
}
.anli_detail_banner {
    position: relative;
    overflow: hidden;
}
.anli_detail_banner img {
    width: 100%;
}
@media only screen and (max-width: 1366px){
.anli_detail_banner .text {
    top: 50%;
}
}
.anli_detail_banner .text {
    position: absolute;
    width: 100%;
    position: absolute;
    top: 55%;
    left: 0;
    transform: translateY(-50%);
    color: #fff;
    text-align: left;
}
.w1000 {
    width: 1000px;
    margin: 0 auto;
    max-width: 94%;
}
.anli_detail_banner .text h2 {
    margin-bottom: 28px;
    width: 65%;
    line-height: 1.88em;
    padding: 0 25px;
}
.anli_detail_banner .text .banner-text {
    margin-bottom: 44px;
    line-height: 1.7em;
    padding: 0 25px;
}
.anli_detail_banner .text h2:before {
    content: "";
    display: block;
    width: 41px;
    height: 34px;
    background: url(../../../assets/yinhao.png);
    opacity: 0.3;
    margin-bottom: 8px;
}
.fnt_18 {
    font-size: 18px;
}
.anli_detail_tag {
  text-align: left;
}
.anli_detail_tag .anli_tag_text {
    padding: 25px;
    background: #fff;
    font-size: 0;
    box-shadow: 1px 1px 20px 5px rgb(0 132 246 / 20%);
    transform: translateY(-50%);
}
.anli_detail_tag .anli_tag_text .img {
    /* padding: 10px; */
    border: 1px solid #eeeeed;
    display: inline-block;
    vertical-align: middle;
}
.anli_detail_tag .anli_tag_text .text {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    color: #888888;
}
.anli_detail_tag .anli_tag_text .img img {
    width: 114px;
}
.anli_detail_tag .anli_tag_text .img .img_mobil {
    display: none;
}
.anli_detail_tag .anli_tag_text .title {
    margin-bottom: 8px;
}
.fnt_16 {
    font-size: 16px;
}
.anli_detail_tag .anli_tag_text .title span:first-child {
    font-weight: 600;
    color: #333333;
    margin-right: 20px;
}
.anli_detail_tag .anli_tag_text .text a {
    color: #888888;
}
@media only screen and (max-width: 1440px){
.fnt_24 {
    font-size: 20px;
}
}
.fnt_24 {
    font-size: 24px;
}
.num_list {
    font-size: 0;
    padding: 2.1% 0;
    text-align: center;
}
.num_item {
    display: inline-block;
    width: 33%;
    color: #888888;
    text-align: center;
    position: relative;
    vertical-align: top;
    padding: 0 10px;
}

.fnt_14 {
    font-size: 14px;
}
.num_item .fnt_32 {
    font-weight: 600;
    color: #0084f6;
}
@media only screen and (max-width: 1440px) {
.fnt_32 {
    font-size: 24px;
}
}
.anli_detail_article {
  text-align: left;
}
h2 {
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 40px;
}
.subtitle {
    color: #2386ee;
    margin-bottom: 20px;
}
.fnt_24 {
    font-size: 24px;
}
.fnt_16 {
    font-size: 16px;
}
.summary p {
    margin-bottom: 1.5em;
    line-height: 2em;
    font-size: 15px;
}
h1 {
  font-size: 30px;
  text-align: center;
  margin-bottom: 10px;
}
.num_item:after {
    content: "";
    width: 1px;
    height: 80px;
    background: #e6e6e6;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.num_item:last-child:after{display: none;}
.floor {
    position: fixed;
    left: 60px;
    top: 30%;
    z-index: 9;
    display: none;
}
.floor ul li::after {
    content: "";
    width: 7px;
    height: 7px;
    top: 50%;
    background: #bcbcbc;
    position: absolute;
    right: -30px;
    border-radius: 100%;
    z-index: 9;
}
.floor ul li.active::after {
    background: #3887f1;
}
.floor ul {
    position: relative;
    padding-right: 30px;
}
.floor ul li {
    padding: 15px 0;
    position: relative;
    cursor: default;
    color: #bcbcbc;
    font-size: 12px;
}
.floor ul::after {
    content: "";
    width: 1px;
    height: 70%;
    top: 17%;
    background: #bcbcbc;
    position: absolute;
    right: 3px;
}
@media only screen and (max-width: 1440px) {
.floor {
    left: 50px;
}
}
</style>>



// WEBPACK FOOTER //
// src/views/successcase/components/Debang.vue